import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { RealPainSection } from './components/RealPainSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhyFailSection } from './components/WhyFailSection';
import { ProtocolSection } from './components/ProtocolSection';
import { AboutKate } from './components/AboutKate';
import { ServicesMenu } from './components/ServicesMenu';
import { FeaturedTreatments } from './components/FeaturedTreatments';
import { GuaranteeSection } from './components/GuaranteeSection';
import { HoursLocation } from './components/HoursLocation';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { PromoBanner } from './components/PromoBanner';
import { LanguageProvider } from './context/LanguageContext';
import { SEOHead } from './components/SEOHead';
import { IntroCurtain } from './components/IntroCurtain';
import { GiftCardSection } from './components/GiftCardSection';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3rcsulke91w9o">
      <SEOHead data-id="element-1" data-mp="3relu8fqg3g86" />
      <IntroCurtain data-id="element-2" data-mp="5ot150vj28n" />
      <div className="min-h-screen bg-brand-white font-sans text-brand-charcoal selection:bg-brand-gold/30" data-id="element-3" data-mp="680tswt8a8y">
        <PromoBanner data-id="element-4" data-mp="2zm4wyibsb90r" />
        <Header data-id="element-5" data-mp="2zmo89g6xiz5t" />
        <main data-id="element-6" data-mp="2zn66ujh2dpgw">
          <HeroSection data-id="element-7" data-mp="33movnqc0akp0" />
          <ServicesMenu data-id="element-8" data-mp="33lwy49yumcw3" />
          <FeaturedTreatments data-id="element-9" data-mp="33nghwajpr62m" />
          <PainSection data-id="element-10" data-mp="33oi3h8ycvayl" />
          <RealPainSection data-id="element-11" data-mp="38m1f013o59mu" />
          <ProtocolSection data-id="element-12" data-mp="38kqau06b9zv7" />
          <TestimonialsSection data-id="element-13" data-mp="38kglmet3bwqk" />
          <WhyFailSection data-id="element-14" data-mp="3dkl42adk71jf" />
          <AboutKate data-id="element-15" data-mp="3dlw727z6k59h" />
          <GuaranteeSection data-id="element-16" data-mp="3dmfolnkx4rmz" />
          <HoursLocation data-id="element-17" data-mp="3dii5h1ycc033" />
          <FAQSection data-id="element-18" data-mp="nw2ak1lu1ioz" />
          <GiftCardSection data-id="element-19" data-mp="nuhj4kutefvc" />
          <FinalCTA data-id="element-20" data-mp="nvanjf6awtab" />
        </main>
        <Footer data-id="element-21" data-mp="sudmqizlo5ad" />
        <WhatsAppFloat data-id="element-22" data-mp="stuclog6yl6w" />
      </div>
    </LanguageProvider>;
}